import React from 'react';

import { Tooltip, Typography } from '@mui/material';

import { getConditionalObject } from 'utils/data';
import { getCommonDateBody } from 'utils/date';
import { formatNumberToCurrencyString } from 'utils/number';
import { getShortenString } from 'utils/string';

import { REASON_MAX_SHOWN_LENGTH, tooltipPopperProps } from './FeeEscalationsForm.constants';

export const getFeeEscalationOptions = feeEscalations => {
  if (feeEscalations.length === 1) {
    return feeEscalations;
  }

  return feeEscalations.map(feeEscalation => ({
    name: `${formatNumberToCurrencyString(feeEscalation.requestedFee)} due ${getCommonDateBody(
      feeEscalation.requestedDueDate,
    )} — ${feeEscalation.reason}`,
    value: feeEscalation.reggoraFeeEscalationId,
  }));
};

export const getFeeEscalationFields = feeEscalationOptions => {
  const feeEscalation = feeEscalationOptions[0];
  const isReasonShortened = feeEscalation.reason.length > REASON_MAX_SHOWN_LENGTH;

  return [
    {
      name: 'Requested fee',
      value: formatNumberToCurrencyString(feeEscalation.requestedFee),
    },
    {
      name: 'Requested due date',
      value: getCommonDateBody(feeEscalation.requestedDueDate),
    },
    {
      name: 'Vendor reason',
      isVertical: true,
      value: feeEscalation.reason,
      ...getConditionalObject(isReasonShortened, () => ({
        valueNode: (
          <Tooltip PopperProps={tooltipPopperProps} placement="top" title={feeEscalation.reason}>
            <Typography variant="medium14">
              {getShortenString(feeEscalation.reason, REASON_MAX_SHOWN_LENGTH)}
            </Typography>
          </Tooltip>
        ),
      })),
    },
  ];
};
